import React, { useRef, useState } from "react";
import Tracker from '@openreplay/tracker';
import './App.css';
import './styles/Footer.css';
//import PurviBaner from "./components/PurviBaner";
import EspoBuiltHeader from "./components/EspoBuiltHeader";
import ZaNas from "./components/ZaNas";
import VtoriBaner from "./web_elements/banner01_hd.png";
import EkipatNi from "./components/EkipatNi";
import ImageScroller from "./components/ImageScroller";
import ImageSlider from "./components/Swiper";
import BasicSwipe from "./components/BasicSwipe";
import ZashtoDaIzberete from "./components/ZashtoDaIzberete";
import Motto from "./components/Motto";
import FAQ from "./components/FAQDropdown";
import FAQItem from "./components/FAQItem";
import CentralArrow from "./components/CentralArrow";
import Footer from "./components/Footer";
import { ReactComponent as Textbox1 } from './web_elements/TextSVG/textbox1_svg-o.svg';
import { ReactComponent as EkipatNiSVG } from './web_elements/TextSVG/textbox2_svg-o.svg';
import { ReactComponent as Textbox3IconsSVG } from './web_elements/TextSVG/texbox3_values_icons_svg-o.svg';
import CallToAction from "./components/CallToAction";
import { ReactComponent as SuperBaner } from './web_elements/SuperBaner-o.svg'
import { ReactComponent as SuperBanerBtn } from './web_elements/SuperBanerBtn-o.svg'
//import SuperBanerImg from './web_elements/SuperBaner2.png';
//import PurviBaner from './web_elements/banner00_nobutton.png'
import PurviBaner from './web_elements/banner1_smaller.jpg';
import SuperBtnImg from './web_elements/SuperBtn.png';
import { ReactComponent as KontaktnaForma } from './web_elements/kontaktna_forma-o.svg'
import BlueDecorativeStripe from "./web_elements/blu_decorative_stripe_full.png";
import FooterLogo from "./web_elements/footer_logo.png";
import ProducersLogo from "./web_elements/s&a_signature_logo.png";
import { motion } from "framer-motion";
//console.log("Tracker Project ID: process.env.REACT_APP_OPENREPLAY_KEY,)
const tracker = new Tracker({
    projectKey: process.env.REACT_APP_OPENREPLAY_KEY,
    ingestPoint: "https://openreplay.topmaterial.org/ingest",
    __DISABLE_SECURE_MODE: true,
});
tracker.start()
function App() {
    const pageStartRef = useRef(null);
    const zaNasRef = useRef(null);
    const uslugiRef = useRef(null);
    const ourValues = useRef(null);
    const callToActionRef = useRef(null);
    const ourFAQRef = useRef(null);
    const [isHovered, setIsHovered] = useState(false);
    console.log("DEBUG: ", process.env.REACT_APP_DEBUG_MODE);
    if (process.env.REACT_APP_DEBUG_MODE === true) {
        Object.keys(process.env)
            .filter(key => key.startsWith('REACT_APP_'))
            .forEach(key => {
                console.log(`${key}: ${process.env[key]}`);
            });
    }
    const handlePageStartScroll = () => {
        pageStartRef.current.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    };

    const handleZaNasScroll = () => {
        zaNasRef.current.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    };


    const handleUslugiScroll = () => {
        uslugiRef.current.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    };

    const handleOurValuesScroll = () => {
        ourValues.current.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    };

    const handleOurFAQScroll = () => {
        ourFAQRef.current.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    };

    const handleCallToActionScroll = () => {
        setTimeout(() => {
            callToActionRef.current.scrollIntoView({ behavior: "smooth", block:"center", inline: "nearest" });
        }, 200); // Delay to allow initial scrollIntoView to complete
    };
    setTimeout(() => {
        window.scrollBy({
            top: -window.innerHeight * 0.5, // Scroll 20% of the viewport height up
            behavior: "smooth",
        });
    }, 1000); // Delay to allow initial scrollIntoView to complete
    const phoneNumber = "+359876265857"; // Replace with your phone number
    const emailAddress = "espobuilt@gmail.com"; // Replace with your email
  return (
      <div className="App">
          <header style={{
              position: "sticky",
              top: 0,
              zIndex: 10000
          }}>
            <EspoBuiltHeader />
          </header>
          <body>
          <div id="super-banner-container" ref={pageStartRef} onClick={handleCallToActionScroll}>
              <img
                  src={PurviBaner}
                  style={{
                      width: "100%",
                      height: "auto"
                  }}
                  alt="">
              </img>
              <motion.div
                  whileTap={{scale: 0.5, duration: 0.8}}
              >
                  <img
                      id="super-banner-btn"
                      src={SuperBtnImg}
                      style={{
                          width: "30%",
                          height: "auto"
                      }}
                      alt="">
                  </img>
              </motion.div>
          </div>
          <div ref={zaNasRef}>
              <Textbox1 id="textbox-1"/>
          </div>
          <img className="vtori-baner"
               style={{
                   position: "relative",
                   zIndex: 2001
               }}
               src={VtoriBaner}
               alt="">
          </img>
          <EkipatNiSVG ref={uslugiRef} id="ekipat-ni"/>
          <div>
            <ImageSlider/>
          </div>
          <Textbox3IconsSVG ref={ourValues} id="our-values"/>
          <div ref={ourFAQRef} id="central-arrow-container">
            <CentralArrow/>
          </div>
          <KontaktnaForma style={{
              width: "42%",
              height: "auto",
          }}/>
          <div ref={callToActionRef}>
            <CallToAction  />
          </div>
          <div id="footer">
              <p className="contact" id="kontakti">Контакти:</p>
              <a href="tel:+359876265857" id="telefon">+359 (87) 6265857<span id="phone-text-only-footer"> - Управител - Запитвания</span></a><br></br>
              <span id="email-text-only-footer">Имейл</span><a href="mailto:espobuilt@gmail.com" className="link-contact"> espobuilt@gmail.com</a>
              <p id="rabotno-vreme" className="contact">Работно време:</p>
              <p id="grafik-na-vreme" className="contact">Понеделник - Събота<br></br>08:00 - 18:00 </p>
              <p onClick={handlePageStartScroll} id="nachalo-link" className="contact">Начало</p>
              <p onClick={handleZaNasScroll} className="contact">За нас</p>
              <p onClick={handleUslugiScroll} className="contact">Услуги</p>
              <p onClick={handleOurValuesScroll} className="contact">Нашите ценности</p>
              <p onClick={handleOurFAQScroll} className="contact">ЧЗВ</p>
              <p onClick={handleCallToActionScroll} className="contact">Контакти</p>
              <p id="trademark" className="contact">2025 ESPO Built. Всички права запазени.</p>
              <img id="blue-stripe-full"
                   src={BlueDecorativeStripe}
                   alt="">
              </img>
              <div id="end-logos">
                  <img className="end-logo" id="footer-logo"
                       src={FooterLogo}
                       alt="footerLogo">
                  </img>
                  <img className="end-logo" id="producers-logo"
                       src={ProducersLogo}
                       alt="producers-logo">
                  </img>
              </div>
          </div>
          </body>
      </div>
  );
}

export default App;